import { useState } from "react";

import pregnancyAnteNatalIcon from "assets/images/pregnancy/ante-natal.svg";
import pregnancyHeartIcon from "assets/images/pregnancy/heart.svg";
import pregnancyPostNatalIcon from "assets/images/pregnancy/post-natal.svg";
import pregnancyMessagesIcon from "assets/images/pregnancy/result.svg";
import showMoreIcon from "assets/images/show-more-icon.svg";
import { views } from "features/pregnancy/hooks/useView";
import { describePregnancyEntry } from "features/pregnancy/utils/pregnancySidebarEntry";

import style from "./PregnancySidebar.module.css";

export const PregnancyItem = ({ pregnancy, view, setView }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { isCompleted, dateLabel, reason } = describePregnancyEntry(pregnancy);

  return (
    <div
      className={`${style.pregnancySidebarItem} ${
        !isExpanded
          ? style.pregnancySidebarItemNotExpanded
          : style.pregnancySidebarItemExpanded
      } ${isCompleted ? style.pregnancySidebarItemCompleted : ""}`}
    >
      <div className={style.pregnancySidebarItemHeaderWrapper}>
        <div className={style.pregnancySidebarItemHeaderInnerWrapper}>
          <button
            className={`${style.pregnancySidebarItemHeaderClickable} ${
              view.pregnancyId === pregnancy.id && view.name === views.general
                ? style.pregnancySidebarItemHeaderClickableActive
                : ""
            }`}
            onClick={() => {
              setIsExpanded((prev) => {
                if (view.pregnancyId === pregnancy.id && view.name === views.general) return !prev;
                return true;
              });
              setView({ name: views.general, pregnancyId: pregnancy.id });
            }}
          >
            <img
              src={pregnancyHeartIcon}
              alt="heart"
              className={isCompleted ? style.completedIcon : undefined}
            />
            <div className={style.pregnancySidebarItemHeaderTitleWrapper}>
              <h3 className={isCompleted ? style.completedTitle : undefined}>
                Pregnancy
              </h3>
              {!!dateLabel && (
                <p style={{ marginTop: "2px" }}>{dateLabel}</p>
              )}
              {/* Free text from the hospital or the GP, and usually the thing worth knowing
                  before opening the record at all. */}
              {!!reason && <p className={style.completionReason}>{reason}</p>}
            </div>
          </button>
          <button
            aria-label="show more"
            className={style.expandToggle}
            onClick={() => setIsExpanded((prev) => !prev)}
          >
            <img src={showMoreIcon} alt="showmore" />
          </button>
        </div>
      </div>
      {isExpanded && (
        <div className={style.pregnancySidebarItemButtonWrapper}>
          <button
            className={`${style.pregnancySidebarItemButton} ${
              view.pregnancyId === pregnancy.id && view.name === views.anteNatal
                ? style.pregnancySidebarItemButtonActive
                : ""
            }`}
            onClick={() =>
              setView({
                name: views.anteNatal,
                pregnancyId: pregnancy.id,
              })
            }
          >
            <img src={pregnancyAnteNatalIcon} alt="ante-natal" />
            Ante-natal
          </button>
          <button
            className={`${style.pregnancySidebarItemButton} ${
              view.pregnancyId === pregnancy.id && view.name === views.postNatal
                ? style.pregnancySidebarItemButtonActive
                : ""
            }`}
            onClick={() =>
              setView({
                name: views.postNatal,
                pregnancyId: pregnancy.id,
              })
            }
          >
            <img src={pregnancyPostNatalIcon} alt="post-natal" />
            Post-natal
          </button>
          <button
            className={`${style.pregnancySidebarItemButton} ${
              view.pregnancyId === pregnancy.id && view.name === views.messages
                ? style.pregnancySidebarItemButtonActive
                : ""
            }`}
            onClick={() =>
              setView({
                name: views.messages,
                pregnancyId: pregnancy.id,
              })
            }
          >
            <img src={pregnancyMessagesIcon} alt="messages" />
            Messages
          </button>
        </div>
      )}
    </div>
  );
};
